"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LogoPart = exports.LogoPartDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var router_1 = require("@reach/router");
var theme_1 = require("@shapeable/theme");
var use_components_1 = require("../../../hooks/use-components");
var shape_logo_1 = require("../../elements/shape-logo");
var shape_logo_inverted_1 = require("../../elements/shape-logo-inverted");
var lodash_1 = require("lodash");
var use_active_person_1 = require("../../../hooks/use-active-person");
exports.LogoPartDefaultProps = {
  minimised: false,
  inverted: false,
  to: '/',
  isSmall: false
};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    height: 24px;\n\n    ", "\n\n    svg {\n      height: 100%;\n    }\n\n    img {\n      height: 100%;\n    }\n  "], ["\n    display: flex;\n    align-items: center;\n    text-decoration: none;\n    height: 24px;\n\n    ", "\n\n    svg {\n      height: 100%;\n    }\n\n    img {\n      height: 100%;\n    }\n  "])), function (props) {
    return props.logoHeightBase && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props.logoHeightBase);
  }),
  tablet: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    height: 32px;\n\n    ", "\n  "], ["\n    height: 32px;\n\n    ", "\n  "])), function (props) {
    return props.logoHeightTablet && (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props.logoHeightTablet);
  }),
  desktop: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    height: 38px;\n\n    ", "\n  "], ["\n    height: 38px;\n\n    ", "\n  "])), function (props) {
    return props.logoHeightDesktop && (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props.logoHeightDesktop);
  }),
  last: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    @media screen and (min-width: 1235px) {\n      margin-left: 0;\n    }\n    @media screen and (min-width: 1024px) and (min-height: 1024px) {\n      height: 48px;\n\n      ", "\n    }\n  "], ["\n    @media screen and (min-width: 1235px) {\n      margin-left: 0;\n    }\n    @media screen and (min-width: 1024px) and (min-height: 1024px) {\n      height: 48px;\n\n      ", "\n    }\n  "])), function (props) {
    return props.logoHeightDesktopTall && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n        height: ", "px;\n      "], ["\n        height: ", "px;\n      "])), props.logoHeightDesktopTall);
  })
});
// -------- Components --- ------->
var My = {
  Container: (0, styled_components_1.default)(router_1.Link)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
var LogoPart = function (props) {
  var className = props.className,
    minimised = props.minimised,
    inverted = props.inverted,
    isSmall = props.isSmall;
  var person = (0, use_active_person_1.useActivePerson)().person;
  var to = props.to;
  if (person) {
    var landingPath = person && person.defaultPath || '';
    to = "/".concat((0, lodash_1.trim)(landingPath, '/'));
  }
  var components = (0, use_components_1.useComponents)();
  var Logo = components.Logo || shape_logo_1.ShapeLogo;
  var LogoInverted = components.LogoInverted || shape_logo_inverted_1.ShapeLogoInverted;
  var containerProps = (0, lodash_1.pickBy)({
    logoHeightBase: process.env.LOGO_HEIGHT_BASE,
    logoHeightTablet: process.env.LOGO_HEIGHT_TABLET,
    logoHeightDesktop: process.env.LOGO_HEIGHT_DESKTOP,
    logoHeightDesktopTall: process.env.LOGO_HEIGHT_DESKTOP_TALL
  });
  var Component = inverted ? LogoInverted : Logo;
  return React.createElement(My.Container, __assign({}, containerProps, {
    to: to,
    className: className
  }), Component && React.createElement(Component, {
    isSmall: isSmall
  }));
};
exports.LogoPart = LogoPart;
exports.LogoPart.defaultProps = exports.LogoPartDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;